import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { useAuth } from '@restworld/feature-authentication';

import { EmployerPrimaryLayoutHeader, EmployerSecondaryLayout } from '../../layouts';
import { EmployerPageContentWrapper } from '../employer-page-content-wrapper';
import { FlexibleSlotsPageContent } from '../flexible-slots-v2';
import { EmployerInvoices } from '../employer-invoices-v2';
import EmployerCompanies from '../employer-companies';
import NextPaymentDetails from '../next-payment-details';
import PpuSubscriptionSlots from './ppu-subscription-slots';
import AvailableCredits from './available-credits';

const PaymentAndInvoices: React.FunctionComponent = (props) => {
  const { t } = useTranslation('payment-and-invoices');
  const { user } = useAuth();

  const isUsingPpuBusinessModel = user?.using_ppu_business_model === true;

  return (
    <EmployerSecondaryLayout title={t('payment_and_invoices_title')}>
      <PageWrapper>
        <EmployerPrimaryLayoutHeader
          pageTitle={t('payment_and_invoices')}
          customHeaderStyles={'pb-[80px]'}
          showInfoIcon={false}
        />
        <div className="flex flex-col gap-[96px]">
          {isUsingPpuBusinessModel ? (
            <>
              <NextPaymentDetails />
              <AvailableCredits />
              <PpuSubscriptionSlots />
            </>
          ) : (
            <FlexibleSlotsPageContent />
          )}
          <EmployerCompanies />
          <EmployerInvoices />
          {/* add other content here */}
        </div>
      </PageWrapper>
    </EmployerSecondaryLayout>
  );
};

export default PaymentAndInvoices;

const PageWrapper = EmployerPageContentWrapper;
